// extracted by mini-css-extract-plugin
export default {"content":"_7c036fed","expanded":"_ff066ae3"};